import i18next from 'i18next';
import ICU from 'i18next-icu';
/**
 * ICU date formats used by comment timestamps. Passed to `IntlMessageFormat` as user-defined
 * formats, so `{date, date, wcShortDate}` in a message resolves to these options.
 */
const icuFormats = {
    date: {
        wcShortDate: { month: 'short', day: '2-digit' },
        wcFullDate: { month: 'short', day: '2-digit', year: 'numeric' },
    },
};
/**
 * Creates a fully initialised, synchronous i18next instance for one locale.
 *
 * This replaces `initI18n` from `@wix/wix-i18n-config` (internal to Wix) with the public
 * packages it wrapped: i18next + i18next-icu. The configuration is the same one it applied —
 * `en` fallback, flat keys, no React suspense — and messages are provided up front, so the
 * instance is ready to translate as soon as this returns.
 */
export function createI18n({ locale, messages, }) {
    const instance = i18next.createInstance();
    instance.use(new ICU({
        formats: icuFormats,
        // Mirrors wix-i18n-config: a message that fails to parse renders as its raw text
        // instead of throwing inside `t()`.
        parseErrorHandler: (_error, _key, res) => res,
    }));
    instance.init({
        lng: locale,
        fallbackLng: 'en',
        // No key separator: translation keys are flat and contain dots.
        keySeparator: false,
        react: { useSuspense: false },
        resources: messages ? { [locale]: { translation: messages } } : undefined,
    });
    return instance;
}
//# sourceMappingURL=i18n.js.map